<div class="layoutBlock">
	<div class="columnHalf">
	
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>

			<div *ngFor="let usageType of usageTypes">
				<res-research-infrastructure-usage 
					[(researchInfrastructureUsages)]="researchInfrastructure.researchInfrastructureUsages" 
					[researchInfrastructureUsageType]="usageType"
					[hisDdKey]="'fs.res.researchInfrastructure.ResearchInfrastructure.' + i18nKeyParameter[usageType.hiskeyId]" 
					[hisDynamicContent]="'fs.res.researchInfrastructure.ResearchInfrastructure.'+ i18nKeyParameter[usageType.hiskeyId]" 
					[dynamicComponent]="researchInfrastructure._dynamicComponent">
				</res-research-infrastructure-usage>
				
				<!-- #anchor dynamic field container -->	
				<ng-template #dynamicFieldSetContainer></ng-template>
			</div>
    </div>
    
	<div class="columnHalf">
	
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	
		<res-research-infrastructure-employments
            [hisDynamicContent]="'fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureEmployment'" [dynamicComponent]="researchInfrastructure._dynamicComponent"
			[(researchInfrastructureEmployments)]="researchInfrastructure.researchInfrastructureEmployments">
		</res-research-infrastructure-employments>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	</div>
</div>